import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";

import Info from "../common/info";
import OptionForm from "./optionForm";

import { OptionFormContainer } from "../../styled/setting";

import { defaultOption } from "../../function/store";

const AddOption = ({ changeTab, selectCompany, openModal, closeModal, getOptions }) => {
  const [option, setOption] = useState(defaultOption);

  const closeForm = () => {
    changeTab(0, null);
    setOption(defaultOption);
    closeModal();
  };

  const handleSave = () => {
    if (!validationCheck()) return;

    openModal({
      type: "confirmation",
      title: "옵션 그룹 추가",
      message: ["옵션 그룹을 추가하시겠습니까?"],
      handleConfirm: createOption,
    });
  };

  const createOption = async () => {
    const url = "/erp/optionGroup/create";

    const formatOpt = ({ value, addPrice, quantity, status, consumeCount }) => ({
      value,
      addPrice: toNumber(addPrice),
      quantity: toNumber(quantity),
      consumeCount: toNumber(consumeCount),
      status,
    });

    const body = {
      ...option,
      status: "READY",
      cmpnyNo: selectCompany.value,
      options: option.options.map(({ id, ...rest }) => formatOpt(rest)),
    };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("옵션 그룹이 등록되었습니다.");
        await getOptions();
        closeForm();
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  const validationCheck = () => {
    if (!option.name) {
      toast.error("옵션그룹명을 입력해주세요.");
      return false;
    }
    if (!option.options?.length) {
      toast.error("옵션 내용이 존재하지 않습니다.");
      return false;
    }

    for (let i = 0; i < option.options.length; i++) {
      const ele = option.options[i];
      const optionIndex = i + 1;

      if (!ele.value) {
        toast.error(`옵션 ${optionIndex}: 옵션명을 입력해주세요.`);
        return false;
      }
      if (!ele.quantity) {
        toast.error(`옵션 ${optionIndex}: 수량을 입력해주세요.`);
        return false;
      }
      if (ele.addPrice === null || ele.addPrice === undefined) {
        toast.error(`옵션 ${optionIndex}: 가격을 입력해주세요.`);
        return false;
      }
    }

    return true;
  };

  return (
    <OptionFormContainer>
      <Info
        message="옵션 그룹 추가"
        actions={[
          {
            label: "취소",
            func: () =>
              openModal({
                type: "confirmation",
                title: "나가기",
                message: ["작업 중인 내용이 사라질 수 있습니다.", "저장하지 않고 나가시겠습니까?"],
                handleConfirm: closeForm,
              }),
            key: "cancel",
          },
          { label: "저장", func: handleSave, key: "add" },
        ]}
      />
      <OptionForm option={option} setOption={setOption} />
    </OptionFormContainer>
  );
};

export default AddOption;
